import { Component } from '@angular/core';
import { ShadowQueryValueRangeProperty } from '../../../shared/services/device-shadow/device-shadow.service';
import {
  FilterType,
  QueryOptions,
  ValueType,
} from '../../query-builder/query-builder.component';
import { ShadowPageBaseComponent } from '../shadow-page-base.component';

@Component({
  selector: 'dcc-ignition-insights',
  templateUrl: '../shadow-page-base.component.html',
  styleUrls: ['../shadow-page-base.component.scss'],
})
export class IgnitionInsightsComponent extends ShadowPageBaseComponent {
  override queryOptions: QueryOptions = {
    name: 'No Ignition',
    description: 'Motion detected, but no Ignition for at least one day.',
    baseFilters: [
      {
        propertyName: ShadowQueryValueRangeProperty.motionWithoutIgnitionSpan,
        value: '1', // 1 days
        filterType: FilterType.RangeStart,
        valueType: ValueType.Text,
      },
    ],
  };
}
